import React from "react";
import ReactJson from "react-json-view";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import { useAppContext } from "../../../../state/app/context";
import QueryStringUtils from "../../../../util/query-string-utils";

const DebugPanel = () => {
	const { state } = useAppContext();
	const debugData = state.debugData();
	const isDebug = QueryStringUtils.useIsDebug();

	return isDebug ? (
		<Accordion
			style={{
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				width: "100%",
				maxHeight: 600,
				overflowY: "scroll",
				opacity: 0.8
			}}
		>
			<AccordionSummary>Debug</AccordionSummary>
			<AccordionDetails>
				<ReactJson src={debugData} displayDataTypes={false} iconStyle="circle" />
			</AccordionDetails>
		</Accordion>
	) : null;
};

export default DebugPanel;
